// @ts-nocheck

import {
  Vue, Options
} from 'vue-class-component'
import * as bootstrap from 'bootstrap'
import router from '@/router/index'
import Header from '@/components/Header.vue'
import CurrencyInput from '@/components/CurrencyInput.vue'
import CurrencyInputDisable from '@/components/CurrencyInputDisable.vue'
import swal from 'sweetalert'
import Utils from '@/utils/utils'
import { customerFactory } from '@/http/customer'
import { masterDataFactory } from '@/http/master-data'
import { usFactory } from '@/http/uang-sekolah'
import constants from '@/constants/constants'
import token from '@/constants/token'
import { setupFactory } from '@/http/setup'

declare let snap: any

@Options({
  components: {
    Header, CurrencyInput, CurrencyInputDisable
  },
  data() {
    return {
      currentSort: 'name',
      currentSortDir: 'asc',
      userPayments: [],
      userBills: [],
      userOrders: [],
      stats: {
        total_bill: 0,
        total_paid: 0,
        allow_mass_checkout: true
      },
      user: {
        name: '',
        class_name: '',
        parents_father: '',
        parents_mother: '',
        user_profile_no_hp: '',
        student_profile_nis: ''
      },
      school: {
        name: ''
      },
      statuses: [],
      schoolYears: [],
      months: [],
      convenienceFee: [],
      data_master: {
        school_years: '1',
        school: '1',
        months: '1',
        convenience_fee: '1'
      },
      param: {
        school_year_id: 0,
        order_at: 'deadline_date'
      },
      school_year_name: '',
      data: {
        bill_name: '',
        school_year_name: '',
        month_name: '',
        fine_rules: {
          value: 0,
          type: 'nominal',
          formula: 'flat',
          late_month_fine: {
            value: 0,
            type: 'nominal',
            formula: 'flat'
          }
        },
        total_amount: 0,
        total_payment: 0,
        late_charge: 0,
        details: [],
        deadline_date: '',
        due_date: '',
        description: '',
        last_date: ''
      },
      totalAmount: 0,
      totalSelecttedAmount: 0,
      totalPaid: 0,
      billCount: 0,
      billIds: [],
      allSelectedBill: false,
      path: process.env.VUE_APP_STORAGE_PATH,
      instance: '',
      subdomain: token.user.subdomain,
      token_order_id: '',
      constants: constants,
      loadingBulk: false,
      loading: [],
      loadingYear: false,
      setting: [],
      convenience_id: [],
      paymentMethod: true,
      payment: {
        amount: 0,
        convenience_fee: 0,
        merchant_fee: 0,
        total_discount: 0,
        ppn: 0,
        total_amount: 0
      },
      tempCheckout: {
        ids: [],
        type: ''
      },
      xenditModal: null,
      bcaModal: null,
      bca: {
        bank_name: '',
        orderId: '',
        invoice_number: '',
        va_number: '',
        va_number_nobill: '',
        amount: 0,
        convenience_fee: 0,
        merchant_fee: 0,
        total_discount: 0,
        ppn: 0,
        total_payment: 0
      },
      xenditInvoice: '',
      discountSetting: '',
      imagepath: null,
      repayUserBillIDs: null,
      disableCheckboxes: 'false',
      useImportVA: false,
      sppPromoAnnuallyPaymentPercentage: 0,
      imported_order: null,
      imported_us_order: null,
      promoTerm: '',
      totalLateCharge: 0,
      billTypes: {},
      canUploadReference: false,
      referenceFile: null,
      orderId: null,
      refundModal: null,
      refundDetails: [],
      totalRefund: 0
    }
  },
  methods: {
    inArray: function (id: any) {
      if (this.billIds.length > 0 && id != '') {
        const exist = this.billIds.indexOf(id)
        if (exist > -1) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    tableDataClass(due_date: any, deadline_date: any, status: any) {
      const duedate = new Date(due_date)
      const datenow = new Date()
      datenow.setHours(0, 0, 0, 0)
      const deadlinedate = new Date(deadline_date)
      let d1 = deadlinedate.getTime()
      if (this.notChargeOnDeadline) {
        // d1 add 1 day
        d1 = d1 + (24 * 60 * 60 * 100)
      }
      const d2 = datenow.getTime()
      const d3 = duedate.getTime()
      let normal; let almostExpired; let expired = false
      if (status == constants.BILL_PENDING || status == constants.BILL_UNPAID) {
        if (d2 >= d1) {
          expired = true
        } else if (d2 > d3 && d3 < d1) {
          almostExpired = true
        } else if (d2 < d3) {
          normal = true
        }
      } else {
        normal = true
      }
      return {
        '': normal,
        'table-warning': almostExpired,
        'table-danger': expired
      }
    },
    onImageLoadFailure: function (event: any) {
      event.target.src = '/img/photos/default-avatar.png'
    },
    checkAllBill: function (bill_type_id: any) {
      this.billIds = []
      if (!this.allSelectedBill) {
        this.userBills.forEach((detail: any) => {
          if (detail.bill.spp_bill_type_id == bill_type_id) {
            if ((detail.status == constants.BILL_PENDING || detail.status == constants.BILL_UNPAID) && detail.spp_order_ids == undefined || this.isCanceled(detail.spp_order_ids)) {
              this.billIds.push(detail.id)
            }
          }
        })
      }
    },
    checkAllBillBySetting: function () {
      this.billIds = []
      if (!this.allSelectedBill) {
        this.userBills.forEach((detail: any) => {
          if ((detail.status == constants.BILL_PENDING || detail.status == constants.BILL_UNPAID) && detail.spp_order_ids == undefined || this.isCanceled(detail.spp_order_ids)) {
            if (detail.discount_setting_id === this.setting.UANGSEKOLAH_DISCOUNT_SETTING) {
              this.billIds.push(detail.id)
            }
          }
        })
      }
    },
    sort: function (s: any) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    getMonth: function (date: any) {
      if (date != '' && date != undefined) {
        const d = date.split('-')
        const month = d[2]
        return this.months[month].id
      } else {
        return ''
      }
    },
    beautifyDate: function (date: any) {
      return Utils.beautifyDate(date)
    },
    toLocaleString: function (val: any) {
      return Utils.toLocaleString(val)
    },
    isCanceled: function (spp_order_ids: any) {
      if (!spp_order_ids) {
        return true
      }

      // if(spp_order_ids.length == 1) {
      //   var result = this.userOrders.find((x:any) => x.id === spp_order_ids[0])
      //   if (!result) {
      //     return false;
      //   }

      //   if (result.status == constants.ORDER_CANCELED || result.status == constants.ORDER_EXPIRED) {
      //     return true
      //   } else {
      //     return false
      //   }
      // } else {
      let status = false
      spp_order_ids.forEach((id) => {
        const result = this.userOrders.find((x: any) => x.id === id)
        if (result && (result.status == constants.ORDER_CANCELED || result.status == constants.ORDER_EXPIRED)) {
          status = true
        }
      })
      // }
    },
    detailBill: function (id: any) {
      Promise.all([
        customerFactory.detailBill(id)
      ]).then(results => {
        if (results[0].error == false) {
          const result = results[0].data.bill_user
          const ppn = result.ppn ? result.ppn : 0
          const deadline_date = new Date(result.deadline_date)
          const y = deadline_date.getFullYear()
          const m = deadline_date.getMonth()
          const last_date = new Date(y, m + 1, 0)
          const last_date_str = Utils.beautifyDate(y + '-' + (m + 1) + '-' + last_date.getDate() + ' 23:59:59')
          const data = {
            school_year_name: this.school_year_name,
            bill_name: result.bill.name,
            month_name: this.getMonth(result.id),
            deadline_date: Utils.beautifyDate(result.deadline_date),
            due_date: Utils.beautifyDate(result.due_date),
            total_amount: result.total_amount,
            total_payment: result.total_amount + result.late_charge + ppn,
            late_charge: result.late_charge,
            ppn: ppn,
            description: result.bill.description,
            fine_rules: result.bill.fine_rules,
            details: result.details,
            last_date: last_date_str
          }

          // Remove bill detail which has 0 amount
          // for (var i =0; i < data.details.length; i++) {
          //   if (!data.details[i].amount) {
          //     data.details.splice(i, 1)
          //     i--
          //   }
          // }

          if (result.bill.fine_rules.length == 0) {
            const fine_rules = {
              value: 0,
              type: 'nominal',
              formula: 'flat',
              late_month_fine: {
                value: 0,
                type: 'nominal',
                formula: 'flat'
              }
            }
            data.fine_rules = fine_rules
          }
          this.data = data
          this.showModal()
        } else if (results[0].response.data.error == true) {
          const errorMessage = results[0].response.data.messages
          swal(errorMessage, '', 'error')
        }
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    },
    resetTempCheckout: function () {
      this.tempCheckout.ids = []
      this.tempCheckout.type = ''
    },
    setTempCheckout: function (ids: any, type: any) {
      this.tempCheckout.ids = ids
      this.tempCheckout.type = type
    },
    resetConvenienceFee: function () {
      this.paymentMethod = true
      this.convenience_id = 0
      const payment = {
        amount: 0,
        convenience_fee: 0,
        merchant_fee: 0,
        total_discount: 0,
        ppn: 0,
        total_amount: 0
      }
      this.payment = payment
    },
    checkOutConvenience: function () {
      this.loadingBulk = true
      const data = {
        convenience_id: this.convenience_id,
        spp_user_bill_ids: this.tempCheckout.ids
      }
      Promise.all([
        customerFactory.checkoutOrder(data)
      ]).then(results => {
        if (results[0].error == false) {
          const us_order_id = results[0].data.order.us_order_id
          const order_id = results[0].data.order.id
          this.handlePayment(us_order_id, order_id)
        } else if (results[0].response.data.error == true) {
          const errorMessage = results[0].response.data.messages
          swal(errorMessage, '', 'error')
        }
        this.loadingBulk = false
      }).catch((e) => {
        // swal("Gagal melakukan request", "", "error")
        this.loadingBulk = false
        console.log(e)
      }).finally(() => {
        this.loadingBulk = false
      })
    },
    bulkCheckout: function (type: any) {
      this.resetTempCheckout()
      this.setTempCheckout(this.billIds, 'bulk')
      if (this.setting.ENABLE_CONVENIENCE_FEE == 'true' && type !== 'pay') {
        this.resetConvenienceFee()
        this.showModal('convenience')
      } else {
        this.loadingBulk = true
        swal({
          title: 'Apakah anda yakin?',
          text: 'Anda akan membayar tagihan terpilih.',
          icon: 'warning',
          buttons: {
            cancel: true,
            confirm: true
          },
          dangerMode: true
        })
          .then((isConfirm) => {
            if (isConfirm) {
              const data = {
                convenience_id: 0,
                spp_user_bill_ids: this.tempCheckout.ids
              }
              Promise.all([
                customerFactory.checkoutOrder(data)
              ]).then(results => {
                if (results[0]) {
                  const us_order_id = results[0].data.order.us_order_id
                  const order_id = results[0].data.order.id
                  this.handlePayment(us_order_id, order_id)
                }
              })
            } else {
              this.loadingBulk = false
            }
          })
          .catch(() => {
            this.loadingBulk = false
          }).finally(() => {
            this.loadingBulk = false
          })
      }
    },
    oneYearCheckout: function (type: any) {
      this.checkAllBillBySetting()
      this.resetTempCheckout()
      this.setTempCheckout(this.billIds, 'bulk')

      if (this.tempCheckout.ids.length == 0) {
        swal('Perhatian',
          'Sudah dibayarkan semua atau masih ada invoice aktif',
          'warning')
        const order = this.findPendingOrder()
        if (order) {
          const invoice_path = `/user/invoice/${order.id}`
          router.push({ path: invoice_path })
        }
        return
      }

      if (this.setting.ENABLE_CONVENIENCE_FEE == 'true' && type !== 'pay') {
        this.resetConvenienceFee()
        this.showModal('convenience')
      } else {
        this.loadingBulk = true
        swal({
          title: 'Apakah anda yakin?',
          text: 'Anda akan membayar tagihan terpilih.',
          icon: 'warning',
          buttons: {
            cancel: true,
            confirm: true
          },
          dangerMode: true
        })
          .then((isConfirm) => {
            if (isConfirm) {
              const data = {
                convenience_id: 0,
                spp_user_bill_ids: this.tempCheckout.ids
              }
              Promise.all([
                customerFactory.checkoutOrder(data)
              ]).then(results => {
                if (results[0].error == false) {
                  const us_order_id = results[0].data.order.us_order_id
                  const order_id = results[0].data.order.id
                  this.handlePayment(us_order_id, order_id)
                } else if (results[0].response.data.error == true) {
                  const errorMessage = results[0].response.data.messages
                  swal(errorMessage, '', 'error')
                }
              }).catch((e) => {
                swal('Gagal melakukan request', '', 'error')
                console.log(e)
              })
            } else {
              this.loadingYear = false
            }
          })
          .catch(() => {
            this.loadingYear = false
          }).finally(() => {
            this.loadingYear = false
          })
      }
    },
    checkout: function (id: any, order_id: any, type: any) {
      const ids: any = []
      this.orderId = null
      ids.push(id)
      this.resetTempCheckout()
      this.setTempCheckout(ids, 'single')
      if (this.setting.ENABLE_CONVENIENCE_FEE == 'true' && type !== 'pay') {
        this.resetConvenienceFee()
        this.showModal('convenience')
      } else {
        if ((order_id != undefined && !this.isCanceled(order_id)) || !this.tempCheckout.ids) {
          this.hideModal('convenience')
          // router.push({path: '/user/invoice', query: {id: order_id[0]}})
          const invoice_path = `/user/invoice/${order_id[0]}`
          router.push({ path: invoice_path })
        } else {
          this.loading[id] = true
          const data = {
            convenience_id: 0,
            spp_user_bill_ids: this.tempCheckout.ids
          }
          Promise.all([
            customerFactory.checkoutOrder(data)
          ]).then(results => {
            if (results[0].error == false) {
              const us_order_id = results[0].data.order.us_order_id || null
              const order_id = results[0].data.order.id || null
              if (us_order_id && order_id) {
                this.handlePayment(us_order_id, order_id)
              } else {
                this.orderId = results[0].data.order.id

                // this.bca.orderId = results[0].data.order.id
                this.bca.invoice_number = results[0].data.order.invoice_no
                this.bca.va_number = results[0].data.order.custom_field2
                // this.bca.va_number_nobill = results[0].data.order.custom_field1
                this.bca.bank_name = results[0].data.order.custom_field3
                this.bca.amount = results[0].data.order.total_amount
                this.bca.convenience_fee = results[0].data.order.convenience_fee
                this.bca.merchant_fee = results[0].data.order.merchant_fee
                this.bca.total_discount = results[0].data.order.total_discount
                this.bca.ppn = results[0].data.order.ppn
                this.bca.total_payment = results[0].data.order.total_payment

                this.canUploadReference = true
                this.referenceFile = null

                this.hideModal('convenience')
                this.bcaModal.show()
              }
            } else if (results[0].error == true) {
              const errorMessage = results[0].messages
              swal(errorMessage, '', 'error')
              this.loading[id] = false
            }
          }).catch((e) => {
            swal('Gagal melakukan request', '', 'error')
            console.log(e)
            this.loading[id] = false
          }).finally(() => {
            this.loading[id] = false
          })
        }
      }
    },
    handleFileUpload: function (event) {
      const file = event.target.files[0]
      this.referenceFile = null // Reset previous file
      // upload file to server
      if (file) {
        const orderId = this.orderId
        customerFactory.uploadReference(orderId, file).then(response => {
          if (response.error == false) {
            this.referenceFile = response.data.file_path
            // reset file input
            event.target.value = ''
            swal('Berhasil mengupload bukti pembayaran', '', 'success')
          } else {
            swal('Gagal mengupload bukti pembayaran', response.messages, 'error')
          }
        }).catch((e) => {
          swal('Gagal mengupload bukti pembayaran', '', 'error')
          console.log(e)
        })
      }
    },
    addSnapJS() {
      const uangsekolah = document.createElement('script')
      const instance = String(localStorage.getItem('instance'))
      uangsekolah.setAttribute('src', localStorage.getItem('base_url') + '/' + instance + '/us/snap.js')
      document.head.appendChild(uangsekolah)
    },
    handlePayment: function (us_order_id: any, order_id: any) {
      Promise.all([
        usFactory.getUSToken(us_order_id)
      ]).then(results => {
        const token_order_id = results[0].data.us_order.token
        const us_order = results[0].data.us_order
        const order = results[0].data.order
        const merchant = us_order.merchant
        const merchant_config = merchant.configs || {}
        const client_key = merchant_config.client_key || ''
        const snap_js_endpoint = merchant_config.snap_js_endpoint || ''

        if (merchant.type == 'midtrans') {
          loadSnapJS(snap_js_endpoint, client_key, function () {
            if (typeof snap === 'undefined') {
              swal('Halaman Belum siap', '', 'error')
              return
            }

            const invoice_path = `/user/invoice/${order_id}`

            snap.pay(token_order_id, {
              uiMode: 'qr',
              gopayMode: 'qr',
              onSuccess: function () {
                window.vueComponent.hideModal('convenience')
                // window.vueRouter.push({path: '/user/invoice', query: {id: order_id}})
                window.vueRouter.push({ path: invoice_path })
                return false
              },
              onPending: function () {
                window.vueComponent.hideModal('convenience')
                // window.vueRouter.push({path: '/user/invoice', query: {id: order_id}})
                window.vueRouter.push({ path: invoice_path })
                return false
              },
              onError: function () {
                return false
              },
              onClose: function () {
                window.vueComponent.hideModal('convenience')
                // window.vueRouter.push({path: '/user/invoice', query: {id: order_id}})
                window.vueRouter.push({ path: invoice_path })
                return false
              }
            })
          })
        } else if (merchant.type == 'xendit') {
          this.xenditInvoice = us_order.link
          this.xenditModal.show()
          // } else if (merchant.type == 'bca' || merchant.type.includes('offline') || merchant.type == 'cimb') {
        } else {
          const bankNames = {
            bca: 'BCA',
            panin: 'Panin',
            cimb: 'CIMB',
            bcah2h: 'BCA',
            permata: 'Permata',
            ocbc: 'OCBC',
            mandiri: 'Mandiri',
            bni: 'BNI',
            bri: 'BRI'
          }

          this.bca.orderId = us_order.order_id
          this.bca.va_number = us_order.custom_field1
          if (merchant.type.includes('offline')) {
            this.bca.va_number_nobill = us_order.custom_field2
            this.bca.bank_name = bankNames[merchant.type.split('-')[0]]
          } else {
            this.bca.bank_name = bankNames[merchant.type]
          }
          this.bca.amount = us_order.total_amount
          this.bca.convenience_fee = order.convenience_fee
          this.bca.merchant_fee = order.merchant_fee
          this.bca.total_discount = order.total_discount
          this.bca.ppn = order.ppn
          this.bca.total_payment = order.total_payment
          this.hideModal('convenience')
          this.bcaModal.show()
        }
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      }).finally(() => {
        this.loadData()
        return false
      })
      return false
    },
    handleConvenienceFee: function (value: any) {
      this.convenience_id = value
      const param = {
        convenience_id: value,
        spp_user_bill_ids: this.tempCheckout.ids
      }
      Promise.resolve(customerFactory.calcConvenienceFee(param))
        .then(result => {
          if (result.error === false) {
            const payment = {
              convenience_fee: result.data.convenience_fee,
              merchant_fee: result.data.merchant_fee,
              amount: result.data.total_amount,
              total_discount: '-' + result.data.total_discount,
              ppn: result.data.ppn,
              total_amount: result.data.total_payment
            }
            this.payment = payment
            this.paymentMethod = false
          } else {
            const errorMessage = result.messages.length ? result.messages[0] : result.messages
            swal(errorMessage, '', 'error')
          }
        }).catch((e) => {
          swal('Gagal melakukan request', '', 'error')
          console.log(e)
        })
      return false
    },
    invoice: function (order_id: any) {
      if (order_id != undefined) {
        const invoice_path = `/user/invoice/${order_id}`
        router.push({ path: invoice_path })
        // router.push({path: '/user/invoice', query: {id: order_id[0]}})
      }
    },
    findPendingOrder() {
      for (const i in this.userOrders) {
        const order = this.userOrders[i]
        if (order.status == constants.ORDER_BEGIN || order.status == constants.ORDER_PENDING) {
          return order
        }
      }
      return null
    },
    loadData: function () {
      Promise.all([
        customerFactory.bill(this.param)
      ]).then(results => {
        const userData = results[0].data.user
        const user = {
          name: ('name' in userData) ? userData.name : '',
          class_name: ('class' in userData) ? ('name' in userData.class) ? userData.class.name : '' : '',
          parent_father: ('parents' in userData) ? ('father' in userData.parents) ? userData.parents.father : '' : '',
          parent_mother: ('parents' in userData) ? ('mother' in userData.parents) ? userData.parents.mother : '' : '',
          user_profile_no_hp: ('user_profile' in userData) ? ('no_hp' in userData.user_profile) ? userData.user_profile.no_hp : '' : '',
          student_profile_nis: ('student_profile' in userData) ? ('nis' in userData.student_profile) ? userData.student_profile.nis : '' : ''
        }
        this.user = user
        this.userBills = results[0].data.user_bills
        this.userBills.forEach((value: any) => {
          value.total_payment = value.total_amount + value.late_charge
          this.totalLateCharge += value.late_charge
          // if('spp_order_ids' in value) value.spp_order_ids.sort().reverse()
        })
        this.stats = results[0].data.stats
        this.statuses = results[0].data.statuses
        this.userOrders = results[0].data.user_orders
        // this.billCount = this.userOrders.length
        // loop user orders to get the bill count
        this.userOrders.forEach((order) => {
          if (order.status >= constants.ORDER_SUCCESS) {
            this.billCount++
          }
        })

        this.billTypes = results[0].data.bill_types

        const path = this.path + this.subdomain + '/student_photos/' + this.user.student_profile_nis + '.jpg'
        this.imagepath = path
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    },
    loadDataMaster: function () {
      const setting_data = {
        title: 'ENABLE_CONVENIENCE_FEE'
      }
      const setting_data_2 = {
        title: 'UANGSEKOLAH_DISCOUNT_SETTING'
      }
      return Promise.all([
        masterDataFactory.master_datas(this.data_master),
        masterDataFactory.setting_data(setting_data),
        masterDataFactory.setting_data(setting_data_2)
      ]).then(results => {
        this.schoolYears = results[0].data.school_years
        this.months = results[0].data.months
        this.school = results[0].data.school
        this.convenienceFee = results[0].data.convenience_fee
        this.schoolYears.forEach((school_year: any) => {
          if (school_year.status == 'Active') {
            this.param.school_year_id = school_year.school_year_id
            this.school_year_name = school_year.name
          }
        })
        var setting = results[1].data.setting
        var value = (setting != null) ? setting.value : ''
        var title = (setting != null) ? setting.title : ''
        this.setting[title] = value
        var setting = results[2].data.setting
        var value = (setting != null) ? setting.value : ''
        var title = (setting != null) ? setting.title : ''
        this.setting[title] = value
        this.loadData()
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    },
    showModal: function (type: any) {
      if (type == 'convenience') {
        this.myModalConvenience.show()
      } else {
        this.myModal.show()
      }
    },
    hideModal: function (type: any) {
      if (type == 'convenience') {
        this.myModalConvenience.hide()
      } else {
        this.myModal.hide()
      }
    },
    showImportedVA: function (spp_order_id) {
      Promise.resolve(
        customerFactory.detailOrder(spp_order_id)
      ).then(res => {
        this.order = res.data.order

        if (res.data.additional_data?.use_manual_upload_payment) {
          this.orderId = res.data.order.id
          this.canUploadReference = true
          this.referenceFile = null
        }

        Promise.resolve(
          usFactory.getUSToken(this.order.us_order.id)
        ).then(res => {
          this.imported_us_order = res.data.us_order
          this.imported_order = res.data.order
        }).catch((e) => {
          swal('Gagal melakukan request', '', 'error')
          console.log(e)
        })
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })

      this.importedVAModal.show()
    },
    uncheckAllBill: function () {
      this.allSelectedBill = false
      this.billIds = []
    },
    async copyValue(mytext) {
      try {
        await navigator.clipboard.writeText(mytext)
        alert('Berhasil Copy')
      } catch ($e) {
        alert('Gagal Copy')
      }
    },
    formatPrice(value) {
      const val = Math.round(value / 1).toFixed(0).replace('.', ',')
      return 'IDR ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    openRefundModal: function (billUserId: any) {
      Promise.all([
        customerFactory.getRefundDetails(billUserId)
      ]).then(results => {
        if (results[0].error == false) {
          this.refundDetails = results[0].data.details
          this.totalRefund = results[0].data.total_refund
          this.refundModal.show()
        } else {
          swal('Gagal mengambil data refund', '', 'error')
        }
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    }
  },
  computed: {
    totalSelectedAmount: function () {
      let totalSelectedAmount = 0
      this.userBills.forEach((detail: any) => {
        if (this.billIds.indexOf(detail.id) != -1) {
          totalSelectedAmount += detail.total_payment
        }
      })

      this.promoTerm = ''

      if (this.sppPromoAnnuallyPaymentPercentage > 0 && totalSelectedAmount > 0) {
        let isDiscounted = false
        // group by second part of the bills id
        const group = this.billIds.reduce((r, a) => {
          r[a.split('-')[1]] = [...r[a.split('-')[1]] || [], a]
          return r
        }, {})
        // set isDiscounted to true if there is a group with more or equal to 12 bills
        Object.keys(group).forEach(key => {
          if (group[key].length >= 12) {
            isDiscounted = true
          }
        })

        const str = this.toLocaleString(totalSelectedAmount)

        if (isDiscounted) {
          totalSelectedAmount = totalSelectedAmount - ((totalSelectedAmount - this.totalLateCharge) * this.sppPromoAnnuallyPaymentPercentage / 100)
        }

        const newStr = this.toLocaleString(totalSelectedAmount)

        if (str == newStr) return str

        this.promoTerm = `Potongan harga ${this.sppPromoAnnuallyPaymentPercentage}% untuk pembayaran 1 tahun`
        if (this.totalLateCharge > 0) {
          this.promoTerm += ' (diluar denda)'
        }
        // buat harga coret
        return `${newStr} <span style="text-decoration: line-through; font-size: 12pt; color: #DC3545;">${str}</span>`
      }

      return this.toLocaleString(totalSelectedAmount)
    },
    config() {
      return {
        currency: 'IDR',
        precision: 0,
        distractionFree: false,
        valueAsInteger: true
      }
    },
    isHideElementYkck: function () {
      return [
        'tkglobalandalan',
        'kbtktarunaandalan',
        'sdglobalandalan',
        'sdtarunaandalan',
        'smpglobalandalan',
        'smptarunaandalan',
        'smatarunaandalan'
      ].includes(this.instance) === false
    }
  },
  async created() {
    Promise.resolve(setupFactory.getFeatureConfigs({ feature_configs: ['spp_disable_bill_checkboxes', 'spp_show_US_import_VA', 'spp_promo_annually_payment_percentage', 'spp_group_bill_as_tab', 'spp_not_charge_on_deadline'] })).then(
      (res) => {
        if ('spp_disable_bill_checkboxes' in res.data.feature_configs) {
          this.disableCheckboxes = res.data.feature_configs.spp_disable_bill_checkboxes
        }
        this.useImportVA = ('spp_show_US_import_VA' in res.data.feature_configs && res.data.feature_configs.spp_show_US_import_VA && res.data.feature_configs.spp_show_US_import_VA == 'true')
        this.groupBillAsTab = ('spp_group_bill_as_tab' in res.data.feature_configs && res.data.feature_configs.spp_group_bill_as_tab && res.data.feature_configs.spp_group_bill_as_tab == 'true')
        this.notChargeOnDeadline = ('spp_not_charge_on_deadline' in res.data.feature_configs && res.data.feature_configs.spp_not_charge_on_deadline && res.data.feature_configs.spp_not_charge_on_deadline == 'true')
        if ('spp_promo_annually_payment_percentage' in res.data.feature_configs) {
          this.sppPromoAnnuallyPaymentPercentage = parseInt(res.data.feature_configs.spp_promo_annually_payment_percentage)
        }
      }
    )

    window.vueComponent = this
    window.vueRouter = router
  },
  async mounted() {
    this.instance = String(localStorage.getItem('instance'))

    await this.loadDataMaster()
    // await this.addSnapJS()

    const myModal = document.getElementById('billDetailModal')
    if (myModal != null) {
      this.myModal = new bootstrap.Modal(myModal)
    }
    const xenditModal = document.getElementById('xenditModal')
    if (xenditModal != null) {
      this.xenditModal = new bootstrap.Modal(xenditModal)
    }
    const bcaModal = document.getElementById('bcaModal')
    if (bcaModal != null) {
      this.bcaModal = new bootstrap.Modal(bcaModal)
    }
    const myModalConvenience = document.getElementById('convenienceFeeModal')
    if (myModalConvenience != null) {
      this.myModalConvenience = new bootstrap.Modal(myModalConvenience)
    }
    const importedVAModal = document.getElementById('importedVAModal')
    if (importedVAModal != null) {
      this.importedVAModal = new bootstrap.Modal(importedVAModal)
    }
    const refundModal = document.getElementById('refundModal')
    if (refundModal != null) {
      this.refundModal = new bootstrap.Modal(refundModal)
    }

    if (this.$route.query.repay_user_bill_ids) {
      this.billIds = this.$route.query.repay_user_bill_ids
      this.bulkCheckout()
    }

    const parent = this

    // if modal close alert
    xenditModal.addEventListener('hidden.bs.modal', function () {
      parent.loadDataMaster()
    })
    bcaModal.addEventListener('hidden.bs.modal', function () {
      parent.loadDataMaster()
    })
    importedVAModal.addEventListener('hidden.bs.modal', function () {
      parent.loadDataMaster()
    })
    myModalConvenience.addEventListener('hidden.bs.modal', function () {
      parent.loadDataMaster()
    })
  }

})

export default class UserBill extends Vue { }
